import { useTranslator } from 'components/shared/hooks';
import { ErrorPage } from 'components/shared/surfaces/ErrorPage/ErrorPage';
import React from 'react';

export const NotFoundView: React.FC = () => {
  const trans = useTranslator();

  return <ErrorPage>{trans('ERROR.NOT-FOUND')}</ErrorPage>;
};
